module.exports = {
  heroes: [
    {
      heroId: 62254,
      background: {
        imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/VGSBHNJ.G59hQ.nYmTO.png',
        portraitImageUrl:
          'https://static.diceplatform.com/prod/original/dce.uefatv/section/4103/UTV_-_Hero_Image_-_Instagram_Stories_282_29.CR3bZ.9y4IC.png',
        gradientLeft: false,
        gradientRight: true,
        gradientTop: false,
        gradientBottom: true,
        animationType: 'NONE',
      },
      title: 'CHAMPIONS LEAGUE',
      description:
        'Take a look at the story of the first week of the round of 16 as Lazio took on Bayern Munich and Manchester City visited Copenhagen',
      textAlignment: 'CENTER',
      alignmentHorizontal: 'RIGHT',
      alignmentVertical: 'MIDDLE',
      primaryButton: {
        ctaText: 'REPLAYS',
        link: {
          type: 'ContentLink',
          event: {
            type: 'PLAYLIST',
            accessLevel: 'GRANTED',
            availablePurchases: [],
            title: 'UCL | Round of 16 | First-Leg',
            description: 'Highlights from the Round of 16 First-Legs in the UEFA Champions League 2023/24 season.',
            id: 20851,
            coverUrl:
              'https://dve-images.imggaming.com/original/p/2024/02/28/hfX0lRN22QuJ7j7hCRBoFD8VryLQNz41-1709079570634.png',
            smallCoverUrl:
              'https://dve-images.imggaming.com/original/p/2024/02/16/IntY8cmsp8Z7U9NlOoWyoB6mVX0MpUce-1708104772965.png',
            posterUrl:
              'https://dve-images.imggaming.com/original/p/2024/02/16/6hdxN2g2cyGnXjCV10J4UYFZsECtIyv9-1708110669468.png',
            vodCount: 8,
            upcomingReleases: [],
            playlistType: 'BASIC',
          },
        },
      },
      secondaryButton: {
        ctaText: 'HIGHLIGHTS',
        link: {
          type: 'ContentLink',
          event: {
            type: 'PLAYLIST',
            accessLevel: 'GRANTED',
            availablePurchases: [],
            title: 'UCL | Round of 16 | First-Leg',
            description: 'Highlights from the Round of 16 First-Legs in the UEFA Champions League 2023/24 season.',
            id: 20851,
            coverUrl:
              'https://dve-images.imggaming.com/original/p/2024/02/28/hfX0lRN22QuJ7j7hCRBoFD8VryLQNz41-1709079570634.png',
            smallCoverUrl:
              'https://dve-images.imggaming.com/original/p/2024/02/16/IntY8cmsp8Z7U9NlOoWyoB6mVX0MpUce-1708104772965.png',
            posterUrl:
              'https://dve-images.imggaming.com/original/p/2024/02/16/6hdxN2g2cyGnXjCV10J4UYFZsECtIyv9-1708110669468.png',
            vodCount: 8,
            upcomingReleases: [],
            playlistType: 'BASIC',
          },
        },
      },
      channelLogo: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/GDSHUIJKOL.Ulpdz.HZ7jO.png',
      titleImage: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/YBHJNSKML_2C.Po60f.fV4Xf.png',
      enabled: true,
      heroComponentsDisplay: {
        showTitle: 'ENABLED',
        showDescription: 'ENABLED',
        showPrimaryCta: 'ENABLED',
      },
      ctaText: 'REPLAYS',
      link: {
        type: 'ContentLink',
        event: {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          availablePurchases: [],
          title: 'UCL | Round of 16 | First-Leg',
          description: 'Highlights from the Round of 16 First-Legs in the UEFA Champions League 2023/24 season.',
          id: 20851,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/hfX0lRN22QuJ7j7hCRBoFD8VryLQNz41-1709079570634.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/IntY8cmsp8Z7U9NlOoWyoB6mVX0MpUce-1708104772965.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/6hdxN2g2cyGnXjCV10J4UYFZsECtIyv9-1708110669468.png',
          vodCount: 8,
          upcomingReleases: [],
          playlistType: 'BASIC',
        },
      },
      imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/VGSBHNJ.G59hQ.nYmTO.png',
    },
    {
      heroId: 64807,
      background: {
        imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/SEDRFTGYHJS.rdUxD.0TfkS.png',
        gradientLeft: false,
        gradientRight: true,
        gradientTop: false,
        gradientBottom: true,
        animationType: 'NONE',
      },
      title: "UEFA WOMEN'S",
      description:
        'Madelen Janogy’s first-half brace set top-tier Sweden on the road to a 5-0 victory away to Bosnia & Herzegovina. Relive the action here!',
      textAlignment: 'CENTER',
      alignmentHorizontal: 'RIGHT',
      alignmentVertical: 'MIDDLE',
      primaryButton: {
        ctaText: 'REPLAYS',
        link: {
          type: 'ContentLink',
          event: {
            type: 'SECTION_LINK',
            accessLevel: 'GRANTED',
            availablePurchases: [],
            id: 153771,
            sectionId: 2972,
            sectionName: 'browse',
            title: ' ',
            description: 'Missing translation',
            thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
            videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
          },
        },
      },
      secondaryButton: {
        ctaText: 'HIGHLIGHTS',
        link: {
          type: 'ContentLink',
          event: {
            type: 'SECTION_LINK',
            accessLevel: 'GRANTED',
            availablePurchases: [],
            id: 153771,
            sectionId: 2972,
            sectionName: 'browse',
            title: ' ',
            description: 'Missing translation',
            thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
            videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
          },
        },
      },
      channelLogo:
        'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/VTGBYHNUJMA_2C.UfJsj.fFlEY.png',
      titleImage:
        'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/UEFA-WOMEN_27S-NAS.Kg0zv.XrViB.png',
      enabled: true,
      heroComponentsDisplay: {
        showTitle: 'ENABLED',
        showDescription: 'ENABLED',
        showPrimaryCta: 'ENABLED',
      },
      ctaText: 'REPLAYS',
      link: {
        type: 'ContentLink',
        event: {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          availablePurchases: [],
          id: 153771,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
          videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
        },
      },
      imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/SEDRFTGYHJS.rdUxD.0TfkS.png',
    },
    {
      heroId: 51058,
      background: {
        imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/SNJMK.mAA7w.nS5vU.png',
        gradientLeft: false,
        gradientRight: true,
        gradientTop: false,
        gradientBottom: true,
        animationType: 'NONE',
      },
      title: 'UEL Group Stage draw',
      description:
        'The Round of 16 begins with Czech outfit Sparta Praha welcoming English-giants Liverpool. Catch that game and all the other ties here on UEFA TV!',
      textAlignment: 'CENTER',
      alignmentHorizontal: 'RIGHT',
      alignmentVertical: 'MIDDLE',
      primaryButton: {
        ctaText: 'WATCH LIVE',
        link: {
          type: 'ContentLink',
          event: {
            type: 'SECTION_LINK',
            accessLevel: 'GRANTED',
            availablePurchases: [],
            id: 153771,
            sectionId: 2972,
            sectionName: 'browse',
            title: ' ',
            description: 'Missing translation',
            thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
            videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
          },
        },
      },
      secondaryButton: {
        ctaText: 'TRAILER',
        link: {
          type: 'ContentLink',
          event: {
            type: 'SECTION_LINK',
            accessLevel: 'GRANTED',
            availablePurchases: [],
            id: 153771,
            sectionId: 2972,
            sectionName: 'browse',
            title: ' ',
            description: 'Missing translation',
            thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
            videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
          },
        },
      },
      channelLogo:
        'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/vbhjnskml_2C.4lMoS.iIEZf.png',
      titleImage:
        'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/EUROPA-LEAGUE-WEB-LOGO.hGkBj.ynZzP.png',
      enabled: true,
      heroComponentsDisplay: {
        showTitle: 'ENABLED',
        showDescription: 'ENABLED',
        showPrimaryCta: 'ENABLED',
      },
      ctaText: 'WATCH LIVE',
      link: {
        type: 'ContentLink',
        event: {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          availablePurchases: [],
          id: 153771,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
          videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
        },
      },
      imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/SNJMK.mAA7w.nS5vU.png',
    },
    {
      heroId: 51246,
      background: {
        imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/NSJMK_2CLS.xtkvk.Yb9cP.png',
        gradientLeft: false,
        gradientRight: true,
        gradientTop: false,
        gradientBottom: true,
        animationType: 'NONE',
      },
      title: 'UECL Group Stage draw',
      description:
        'Teams are waiting with bated-breath over who they will face in the Round of 16. Watch the draw live on UEFA TV!',
      textAlignment: 'CENTER',
      alignmentHorizontal: 'RIGHT',
      alignmentVertical: 'MIDDLE',
      primaryButton: {
        ctaText: 'LIVE TODAY 14.30 CET',
        link: {
          type: 'ContentLink',
          event: {
            type: 'SECTION_LINK',
            accessLevel: 'GRANTED',
            availablePurchases: [],
            id: 153771,
            sectionId: 2972,
            sectionName: 'browse',
            title: ' ',
            description: 'Missing translation',
            thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
            videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
          },
        },
      },
      secondaryButton: {
        ctaText: 'PREVIEW',
        link: {
          type: 'ContentLink',
          event: {
            type: 'SECTION_LINK',
            accessLevel: 'GRANTED',
            availablePurchases: [],
            id: 153771,
            sectionId: 2972,
            sectionName: 'browse',
            title: ' ',
            description: 'Missing translation',
            thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
            videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
          },
        },
      },
      channelLogo:
        'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/X_2C._3B-_27Z.h1IWF.m4pVz.png',
      titleImage: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/VGSBHNJMK.Q04e7.q12Uw.png',
      enabled: true,
      heroComponentsDisplay: {
        showTitle: 'ENABLED',
        showDescription: 'ENABLED',
        showPrimaryCta: 'ENABLED',
      },
      ctaText: 'LIVE TODAY 14.30 CET',
      link: {
        type: 'ContentLink',
        event: {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          availablePurchases: [],
          id: 153771,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
          videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
        },
      },
      imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/NSJMK_2CLS.xtkvk.Yb9cP.png',
    },
    {
      heroId: 64808,
      background: {
        imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/VGBZHYJNUM.MhNzT.riUBn.png',
        gradientLeft: false,
        gradientRight: true,
        gradientTop: false,
        gradientBottom: true,
        animationType: 'NONE',
      },
      title: 'THE AMATEURS',
      description:
        'This heartwarming documentary takes us on a captivating journey into the lives of amateur footballers. From carpenters to barbers, businessmen to teachers, these players come from all walks of life, united by their shared love for football.',
      textAlignment: 'CENTER',
      alignmentHorizontal: 'RIGHT',
      alignmentVertical: 'MIDDLE',
      primaryButton: {
        ctaText: 'WATCH HERE',
        link: {
          type: 'ExternalLink',
          url: 'https://www.uefa.com/',
        },
      },
      secondaryButton: {
        ctaText: 'TRAILER',
        link: {
          type: 'ContentLink',
          event: {
            type: 'SECTION_LINK',
            accessLevel: 'GRANTED',
            availablePurchases: [],
            id: 153771,
            sectionId: 2972,
            sectionName: 'browse',
            title: ' ',
            description: 'Missing translation',
            thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
            videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
          },
        },
      },
      titleImage: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/RFSGTBYHJMK.ydLNv.d5qAe.png',
      enabled: true,
      heroComponentsDisplay: {
        showTitle: 'ENABLED',
        showDescription: 'ENABLED',
        showPrimaryCta: 'ENABLED',
      },
      ctaText: 'WATCH HERE',
      link: {
        type: 'ExternalLink',
        url: 'https://www.uefa.com/',
      },
      imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/VGBZHYJNUM.MhNzT.riUBn.png',
    },
  ],
  buckets: [
    {
      type: 'PLAYLISTS',
      rowTypeData: {
        background: {
          gradientLeft: false,
          gradientRight: true,
          gradientTop: false,
          gradientBottom: true,
          animationType: 'NONE',
        },
        title: 'UCL MATCH OF THE WEEK',
        description: 'Match re-runs, extended highlights and more.',
        rowCount: 1,
        rowType: 'INLINE',
        textAlignment: 'LEFT',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: true,
        metadataDisplayMode: 'HIDDEN',
        videoDurationDisplayMode: 'SHOW',
      },
      name: 'UCL MATCH OF THE WEEK',
      exid: 'sxku',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:26519',
      },
      contentList: [
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'MATCH OF THE WEEK: LIVERPOOL 0-1 PARIS (1-4 PENS)',
          description: 'Watch the full 120 minutes as Paris squeezed past Liverpool and into the quarter-finals.\n',
          id: 29995,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2025/03/14/jEA0tTJv4fsMGavZNuPx2i8yH29kG1uC-1741958588227.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2025/03/14/b7dj6cmaW6dddJ5B1Dx4nRfnuUwHClsC-1741955899463.png',
          vodCount: 5,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL MATCH OF THE WEEK: BENFICA 3-3 MONACO',
          description:
            "Catch all the drama from a thriller in Lisbon, where Benfica squeezed into the round of 16 at Monaco's expense.\n",
          id: 29481,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2025/02/20/vrKEadeHKjATRpzuIf09tnptGudrifAD-1740090676105.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2025/02/20/cBpiIugxdRIaf9BcXGN2VT0jC2N6Nbgv-1740094475632.png',
          vodCount: 4,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL MATCH OF THE WEEK: ASTON VILLA 4-2 CELTIC',
          description:
            "Watch the full 90 minutes as Aston Villa progressed to the Round of 16 after bouncing back from Celtic's equaliser.\n",
          id: 28790,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2025/01/30/bdixsVYHqaNbGgFblEqRys810FaVCe1X-1738251596640.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2025/02/04/nMhgw8ToOL9DIgcTOeYqhrP9MGpKrp8F-1738682744033.png',
          vodCount: 5,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL MATCH OF THE WEEK: BENFICA 4-5 BARCELONA',
          description:
            'Watch the full 90 minutes as Vangelis Pavlidis hit a first-half hat-trick for Benfica but Barcelona fought back to claim a spectacular late victory in Lisbon.\n',
          id: 28486,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2025/01/23/uLxGiRXZdQOrLgpvp6wnRU9OziyNVR8y-1737645365952.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2025/02/04/LMOn9hqzICa5jUq6P5xqpG7Dqw3SMf1S-1738682947830.png',
          vodCount: 6,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL MATCH OF THE WEEK: B. DORTMUND 2-3 BARCELONA',
          description:
            'Watch the best of the action from a thrilling encounter with a Ferran Torres double proving decisive for Barcelona.\n',
          id: 27985,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/12/16/uYz1Gt5s8azhH01MxkFo19VTDBtZI84N-1734338919025.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/12/16/rIGG1ReK9cvyfFC4zeDGy6TkthlqDBAy-1734344770102.png',
          vodCount: 5,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL MATCH OF THE WEEK: MAN CITY 3-3 FEYENOORD',
          description:
            'See how Feyenoord came from 3-0 down to score three late goals and earn a remarkable point in Manchester.\n',
          id: 27679,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/11/28/chCWRicZasvUBK1n4qIKSgKWrT5sg0xW-1732833708759.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/12/03/BirQKyQ8ucDao4lbwgWiCRxy8fMcPOCZ-1733225140481.png',
          vodCount: 5,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL MATCH OF THE WEEK: SPORTING CP 4-1 MAN CITY',
          description:
            'Watch all the action as Sporting stunned Manchester City, with Viktor Gyökeres scoring a hat-trick.\n',
          id: 27422,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/11/07/X1yrj2VgRbhWiZx1XUB2HLDgF0mPe9Ga-1731007598802.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/12/03/ngkTYyiBO23nThsDtyLk4a16h7F9cDax-1733231782404.png',
          vodCount: 4,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL MATCH OF THE WEEK: REAL MADRID 5-2 DORTMUND',
          description:
            'Watch all the action as a Vinícius Júnior hat-trick helped Real Madrid come from two goals down to beat Dortmund.\n',
          id: 27196,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/10/24/1ysW6yvwsUkNBu1ega9wIyYbOSqObASv-1729801874837.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/12/03/Yyji7YzyWa8Wb57ixab34rWaUUd2H2dK-1733232576027.png',
          vodCount: 3,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL MATCH OF THE WEEK: DORTMUND 7-1 CELTIC',
          description:
            'Watch the best of the action as Dortmund thrashed Celtic, taking their tally to 10 goals in two Champions League matches.\n',
          id: 26861,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/10/04/BSvKdWrdNFYWzJ0TEaIJ97P5xgIro19Y-1728076769446.jpg',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/12/03/BL3C1fnH2AH4JwnjpfRjk7GjxSur7yoa-1733232870993.png',
          vodCount: 3,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL MATCH OF THE WEEK: BAYERN 9-2 GNK DINAMO',
          description:
            'See how Bayern München became the first club to score nine goals in a game in Champions League history.\n',
          id: 26519,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/09/24/c8CnFqn1yZ2iqhqsH5ZQg45gqYU1fv3a-1727162418963.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/12/03/7l2qhzOB1absCPFKgZBzOYzQMutYWPIm-1733233135817.png',
          vodCount: 4,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
      ],
      placeholderData: {},
    },
    {
      type: 'SECTION_LINK',
      rowTypeData: {
        background: {
          gradientLeft: false,
          gradientRight: false,
          gradientTop: false,
          gradientBottom: false,
          animationType: 'NONE',
        },
        title: ' ',
        rowCount: 1,
        rowType: 'BASIC',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: ' ',
      exid: 'yf-V',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:153776',
      },
      contentList: [
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153771,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/REMS.METZd.Wpoek.png',
          videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/MR.3Dfbu.H8tIZ.mp4',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153772,
          sectionId: 3651,
          sectionName: 'Highlights',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/HIGHLIGHTS-1.r9Dvy.bWLUL.png',
          videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/NMKSS.IKExQ.k9d6B.mp4',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153773,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/EXTEND.Nip1O.0zHBY.png',
          videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/DJDKM_2C.SuvJI.dUFkd.mp4',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153774,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/SUHJIKL_2C.LXd7F.3f1FI.png',
          videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/UEFA-_2.HQhPU.rQsDG.mp4',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153775,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/UINTERVIEWS.WolAd.KbeYH.png',
          videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/INFSSDmp4.2kj1v.ihcvX.mp4',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153776,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/SJKML_2C.y11qG.95m5q.png',
          videoUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/UEFA-ORC.To5P5.SbbNQ.mp4',
        },
      ],
      placeholderData: {},
    },
    {
      type: 'VOD_VIDEO',
      rowTypeData: {
        background: {
          gradientLeft: false,
          gradientRight: false,
          gradientTop: false,
          gradientBottom: false,
          animationType: 'NONE',
        },
        title: "EDITOR'S PICKS",
        description: "Europe's elite take to the stage in of world football's most prestigious tournaments.",
        rowCount: 1,
        rowType: 'BASIC',
        contentDescription: 'SHOW',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: "EDITOR'S PICKS",
      exid: 'PbKX',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:590941',
      },
      contentList: [
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'FC Porto v Arsenal | 23/24 UCL Highlights',
          description: 'See how a stunning Galeno strike earned FC Porto a first-leg advantage to take to London.',
          id: 590805,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/29/ajadTBnsva4NMvujjEDzI4IOqocK3qIt-1709222505380.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/05/iExh6VFC0xWoQoL5X5jfwRyK5UF8LQGD-1709647141597.png',
          duration: 120,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/29/hw5gzCuSTzpcacM1vn57s9ffAXdMjXmW-1709208470932/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'DENIED',
          licenceIds: [],
          title: 'Player Focus | Tuta',
          description:
            "We meet Frankfurt's defender Tuta and know more about his journey and his UEFA Europa League title in 2022.",
          id: 586556,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/wswsSffA3l3WfoSSi8uWVxu3XnXSTinS-1708439884395.png',
          duration: 222,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/3lQQqoIZ2RCHPFWfsmBqn3fdT3A2yDqp-1708439796527/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED_ON_SIGN',
          licenceIds: [],
          title: 'France | Euro 2024 Qualifying - All Goals',
          description: 'Watch every goal scored by France in the EURO 2024 qualifying campaign.',
          id: 589843,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/oK2uG6eiy8SVlG8j6llBYse7tYJd0WVY-1709075286611.png',
          duration: 486,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/27/Lrhg1XXSGKmUiQfIL148MmsozigRsQei-1709055242274/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Equals | Episode 6 | The Start, not the End',
          description:
            "We capture the current state of play and where the game could grow from here. Through showcasing the final of Women's EURO it is also an opportunity to discuss how records have been broken and will continue to be made going forward.",
          id: 589599,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/BihIM3Xe9wurtRCJNbnjeWPudb04sOjo-1709032894496.jpg',
          duration: 1393,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/26/9WVBOYDhruqUJpDVKABSDzkx1BXceaLp-1708982953703/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Group Stage Review | 2023/24',
          description: "Ahead of the competition's resumption, relive the action from the group stage.",
          id: 590944,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/29/NwGsP6CGcGRQNhmLVNIJLoJX5qYNPhJB-1709224786553.jpg',
          duration: 1074,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/29/FqwTtPhZhBrqNdcouZ1bDUsz1JxoLFHM-1709224649988/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UEL Draw | Qualified Teams',
          description: 'We look at the teams that have qualified for the UEFA Europa League Round of 16.',
          id: 590939,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/29/r5PD7RF00vdGUac60QBjY7OP99I8TOAJ-1709224375980.jpg',
          duration: 163,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/29/NJ46VIaCtbmYp4rFKabTCF8WJR7JspUo-1709224204920/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Head-to-head | UEL Knockout Round Play-offs',
          description: 'We preview more fascinating fixtures.',
          id: 590940,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/29/NyjKlQ2QEpx3OkZgW03dYMTep7WApNwC-1709224460850.jpg',
          duration: 171,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/29/VPhvQ23NOZUCoaUEFyrc4zFCIvvK9p8o-1709224153359/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Matchday Moments | Round of 16 1st Leg',
          description: 'Relive all the key moments from the first leg of the UEFA Champions League Round of 16.',
          id: 590943,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/29/hmdQPhrSNfIkTdwp6DoF364KE0GMhcWg-1709224539101.jpg',
          duration: 468,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/29/F5DtaKGD1ihj2NJEEK77fMYtkMxqraIt-1709224395492/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Missing Pieces | Karim Adeyemi',
          description: "Dortmund's star answers questions about his team's successful group stage.",
          id: 590941,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/29/ybE7YXzpfEArFu30Z7TFCRxwAidAvCFM-1709224296503.jpeg',
          duration: 190,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/29/RDkaj3ogn4Uwd6p8epvwTU86KSFW6tqE-1709224212279/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
      ],
      placeholderData: {},
    },
    {
      type: 'SECTION_LINK',
      rowTypeData: {
        background: {
          gradientLeft: false,
          gradientRight: false,
          gradientTop: false,
          gradientBottom: false,
          animationType: 'NONE',
        },
        title: ' ',
        rowCount: 1,
        rowType: 'BASIC',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: ' ',
      exid: 'ofc~',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:153662',
      },
      contentList: [
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153655,
          sectionId: 3641,
          sectionName: 'CHAMPIONS LEAGUE',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/ucl.TKQPh.EGfAd.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153656,
          sectionId: 2992,
          sectionName: 'EL',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/uel.86QZI.X1Q3n.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153657,
          sectionId: 2991,
          sectionName: 'ECL',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/uecl.QzW0G.i6RU3.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153658,
          sectionId: 2990,
          sectionName: 'CL',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/euroq.IYUZh.zf2zq.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153659,
          sectionId: 2990,
          sectionName: 'CL',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/euro2024.AxDIG.Q8CDT.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153660,
          sectionId: 2990,
          sectionName: 'CL',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/unl.gx1qU.JPyc5.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153661,
          sectionId: 3472,
          sectionName: 'SCUP',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/gyhujik.za7pN.FxEla.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153662,
          sectionId: 3471,
          sectionName: 'UYL',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/cvgbhnjkml_2C._3B.rLIti.IFNmC.png',
        },
      ],
      placeholderData: {},
    },
    {
      type: 'SECTION_LINK',
      rowTypeData: {
        background: {
          gradientLeft: false,
          gradientRight: false,
          gradientTop: false,
          gradientBottom: false,
          animationType: 'NONE',
        },
        title: ' ',
        rowCount: 1,
        rowType: 'BASIC',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: ' ',
      exid: 'Em_b',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:153306',
      },
      contentList: [
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153299,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/uyl.X4AeP.yO84d.cQjdk.xJtdE.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153300,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/u21.lYA82.bEPAJ_281_29.PSGsG.x8jZt.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153301,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/u19.5ziIT.rJnpJ.gTAEw.BIKJv.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153302,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/wu19.KL9kB.XyCz8.bN6jb.JBX1a.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153303,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/u17.hQJ8T.rYH14.B36ih.w0rvT.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153304,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/futcalchamp.5zwFn.hUJN1.6VONN.V6oux.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153305,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/futsaleuro.cmSqn.dyklD.QzZTo.2J6jD.png',
        },
        {
          type: 'SECTION_LINK',
          accessLevel: 'GRANTED',
          licenceIds: [],
          id: 153306,
          sectionId: 2972,
          sectionName: 'browse',
          title: ' ',
          description: 'Missing translation',
          thumbnailUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/womenferuo.lIxcR.6PhBi.dwnDE.etAYM.png',
        },
      ],
      placeholderData: {},
    },
    {
      type: 'PLAYLISTS',
      rowTypeData: {
        background: {
          imageUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/BHSJNKML_2C.9VdjL.Sbffx.png',
          gradientLeft: true,
          gradientRight: true,
          gradientTop: true,
          gradientBottom: true,
          animationType: 'NONE',
        },
        title: 'UEFA CHAMPIONS LEAGUE HIGHLIGHTS',
        description: "Europe's elite take to the stage in of world football's most prestigious tournaments.",
        rowCount: 1,
        rowType: 'INLINE',
        textAlignment: 'LEFT',
        contentDescription: 'SHOW',
        focusStyle: 'NONE',
        playlistImageType: 'POSTER',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: 'UEFA CHAMPIONS LEAGUE HIGHLIGHTS',
      exid: 'Pn7u',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:20845',
      },
      contentList: [
        {
          type: 'PLAYLIST',
          accessLevel: 'DENIED',
          licenceIds: [],
          title: 'UCL | Round of 16 | First-Leg',
          description: 'Highlights from the Round of 16 First-Legs in the UEFA Champions League 2023/24 season.',
          id: 20851,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/hfX0lRN22QuJ7j7hCRBoFD8VryLQNz41-1709079570634.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/IntY8cmsp8Z7U9NlOoWyoB6mVX0MpUce-1708104772965.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/6hdxN2g2cyGnXjCV10J4UYFZsECtIyv9-1708110669468.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL | Group Stage | Matchday 6',
          description: 'Highlights from the Matchday 6 in the Group Stage of the UEFA Champions League 2023/24 season.',
          id: 20850,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/920QE5Lz9uyGy5z1RU4UbbRn4x7bRk64-1709079721666.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/yqJkMnRPmtr5FRdF33rvwVaQnZW0dD8V-1708104734467.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/QimC1d4wJq1Uivxs6rfb7JDdHwiAka32-1708110637734.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL | Group Stage | Matchday 5',
          description: 'Highlights from the Matchday 5 in the Group Stage of the UEFA Champions League 2023/24 season.',
          id: 20849,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/giCUkWjnER1SFnr3wylrpNcYHVNnzojT-1709079802642.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/FGwQwF2O9HXuzG9IABGybb8Mizde9YYE-1708104689769.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/hfVHydaKQrdHpZJTBM39tI85UMyxk6dR-1708110611443.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL | Group Stage | Matchday 4',
          description: 'Highlights from the Matchday 4 in the Group Stage of the UEFA Champions League 2023/24 season.',
          id: 20848,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/ryysGk5Mbu9E1wFLwE3L7BWxIB9NLP7X-1709079917314.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/tlMCfnvbiLGHbLqFIwFwPQwhBJ9s0REo-1708104627930.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/byuJz9biVNGIeTCCO09AO5dhR8OuWUZS-1708110588448.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL | Group Stage | Matchday 3',
          description: 'Highlights from the Matchday 3 in the Group Stage of the UEFA Champions League 2023/24 season.',
          id: 20847,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/GB47tHAdkDEKwcuM9ediZO9t6WX9A5Ie-1709080012486.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/9hdzwDDgF1nTdZ9VPXPABhylvffVhLzU-1708104591040.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/yp3IORGT5CBT6CJYDmc0zExCMKrXYHmH-1708110567482.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL | Group Stage | Matchday 2',
          description: 'Highlights from the Matchday 2 in the Group Stage of the UEFA Champions League 2023/24 season.',
          id: 20846,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/tgaVXrhIB6To8fGpHPEQPK9HTrlH0khV-1709080108918.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/rttX3BPBFpxSP3kIP3AmXWxRslIQJOTa-1708104571145.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/SXZf1BNaqnh83qOcUj7G6rmWpK6TC1F3-1708110540994.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL | Group Stage | Matchday 1',
          description: 'Highlights from the Matchday 1 in the Group Stage of the UEFA Champions League 2023/24 season.',
          id: 20845,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/0OegclkUXJBaFnMg8aM2KkbcpFqVWDQg-1709080210487.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/moqTR63oD385GfrPcZkTb2qdC3hamc45-1708104535421.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/BHO2cTpOIhtcbMC9lG8ZHX7NBtkpZlZj-1708110513608.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
      ],
      placeholderData: {},
    },
    {
      type: 'PLAYLISTS',
      rowTypeData: {
        background: {
          imageUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/DERFTGYHJMK_2C.PhKCt.FnT4k.png',
          gradientLeft: true,
          gradientRight: true,
          gradientTop: true,
          gradientBottom: true,
          animationType: 'NONE',
        },
        title: 'UEFA EUROPA LEAGUE',
        description: 'Watch all the action from across the continent via our dedicated highlights!',
        rowCount: 1,
        rowType: 'INLINE',
        textAlignment: 'LEFT',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'POSTER',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: 'UEFA EUROPA LEAGUE',
      exid: 'RCsf',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:20853',
      },
      contentList: [
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UEL | Play-off | First-Leg',
          description: 'Highlights from the First-Legs in the Round of 32 from the UEFA Europa League 2023/24 season.',
          id: 20860,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/UtOGRNIL3MeZ5lHWrskC3FkZbLfE5yyO-1709114054114.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/WpNPMX06Pm1gRGoty6MvTalhXYSKs9WU-1708111491632.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/2SSSoEujmBhuj3KTyBIyLuqYEBPhhFrI-1708111513799.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UEL | Group Stage | Matchday 6',
          description: 'Highlights from the Matchday 6 in the Group Stage of the UEFA Europa League 2023/24 season.',
          id: 20859,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/bySr4CLlTqE8blyg94XTwP6cVXMgknnn-1709114460843.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/uZnZsLhZtn1bJI0nlFBgFbmtKXVicMLY-1708111467984.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/AnXF1Flc792MAE15H2zsTTNQnhEjWaLQ-1708111474426.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UEL | Group Stage | Matchday 5',
          description: 'Highlights from the Matchday 5 in the Group Stage of the UEFA Europa League 2023/24 season.',
          id: 20857,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/AFPuCBTPHE4gU0t2iFPpYkGMVJkJioUs-1709114905316.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/Xg1BweTNv5AMKxd2lZOwmvrv5ZPISuZX-1708111402867.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/DLpC9iyic4kBMWDkgrryZwnkTsD8XnDu-1708111408771.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UEL | Group Stage | Matchday 4',
          description: 'Highlights from the Matchday 4 in the Group Stage of the UEFA Europa League 2023/24 season.',
          id: 20856,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/051716X2PPxXesW1cDz7VJdfJbQDE6de-1709115116242.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/Q6oOpkbul3tJRSEYWGQnLpIdUa5gsu9f-1708111360614.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/0npHdeR8GQcPEBsQDRImpZY46ZcZFB23-1708111373056.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UEL | Group Stage | Matchday 3',
          description: 'Highlights from the Matchday 3 in the Group Stage of the UEFA Europa League 2023/24 season.',
          id: 20855,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/aaxVmucrMsNlVAYBXCc7gQozBUkNESX8-1709115234582.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/OFIhmDAFvcJDPdQSvKT72dXxWOBawib6-1708111331591.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/WlkGjZEgMVYABiaQTg85T7IAGv37x8MN-1708111334605.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UEL | Group Stage | Matchday 2',
          description: 'Highlights from the Matchday 2 in the Group Stage of the UEFA Europa League 2023/24 season.',
          id: 20854,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/7PARpY9HXaM3s94q14uFYcc4JhmeJWfu-1709115335497.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/IHLb2Z2KE3ysb69DXlkedzS2gtWSVF8B-1708111305586.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/Y1LQXxWBcxqVEyoGnQmJbkIuHAJV4WDp-1708111311164.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UEL | Group Stage | Matchday 1',
          description: 'Highlights from the Matchday 1 in the Group Stage of the UEFA Europa League 2023/24 season.',
          id: 20853,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/elcotVTF4v7ZD1RI3KKPzVrSsMjZ4JzM-1709115413122.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/TjEQm4Z9ARRjM9vlvrOjYy7m0L6IiEBM-1708111255458.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/kygoqq7AyEztKPQiGkCohHCu61D2VfDZ-1708111258274.png',
          vodCount: 8,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
      ],
      placeholderData: {},
    },
    {
      type: 'PLAYLISTS',
      rowTypeData: {
        background: {
          imageUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/VGBHNJMKSDL_2C..FCcOP.n89Db.png',
          gradientLeft: true,
          gradientRight: true,
          gradientTop: true,
          gradientBottom: true,
          animationType: 'NONE',
        },
        title: 'UEFA EUROPA CONFERENCE LEAGUE',
        description: "Enjoy all that's on offer from the continent's newest competition ! ",
        rowCount: 1,
        rowType: 'INLINE',
        textAlignment: 'LEFT',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'POSTER',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: 'UEFA EUROPA CONFERENCE LEAGUE',
      exid: 'XXT.',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:20862',
      },
      contentList: [
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UECL | Play-off | First Leg',
          description:
            'Highlights from the First-Legs in the Round of 32 from the UEFA Europa Conference League 2023/24 season.',
          id: 20868,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/e4VezbBSDeADzZ6ypnla8mEZFGCUQnTz-1709115762846.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/l9FQXQTyud3dLiE7ce7s9nAm8PdaIMcO-1708113696294.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/Y41khhPu09kx9Gan9NHb1PFJiRmVtV34-1708113727584.png',
          vodCount: 1,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UECL | Group Stage | Matchday 6',
          description:
            'Highlights from the Matchday 6 in the Group Stage from the UEFA Europa Conference League 2023/24 season.',
          id: 20867,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/pCpRARvp6kEw6W7KPNxISodh51b5x6Ml-1709115941100.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/J4ieFxseyVJuM6PfIqXfgpyiNxeVKVVA-1708113670694.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/KHFdKxe4TCi3YuDKtHOqZjYbDjRduoVI-1708113681198.png',
          vodCount: 1,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UECL | Group Stage | Matchday 5',
          description:
            'Highlights from the Matchday 5 in the Group Stage from the UEFA Europa Conference League 2023/24 season.',
          id: 20866,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/g1roBz4ZMNB21kg0F42vWprn8lbgBfxu-1709116050437.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/ZlS5MQEEKoLz6f9GyO7ql4hSzIXOOFfO-1708113652007.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/awLc6cNTPGDtTlISbzdRvtmwpLYtYpiS-1708113654464.png',
          vodCount: 1,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UECL | Group Stage | Matchday 4',
          description:
            'Highlights from the Matchday 4 in the Group Stage from the UEFA Europa Conference League 2023/24 season.',
          id: 20865,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/bhhfrEuQQw8MMjywuW5wjgzfoE5LUY0V-1709116177997.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/qjOlVEFx8JZWzxgGc1oGNHyUyoxvBlHd-1708113624567.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/uwdsFPLrWdMmKOdUTeWC45iu46NqON6C-1708113631318.png',
          vodCount: 1,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UECL | Group Stage | Matchday 3',
          description:
            'Highlights from the Matchday 3 in the Group Stage from the UEFA Europa Conference League 2023/24 season.',
          id: 20864,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/17dx0EmlQVDyv6DfKwYGoAPMvGUaQsFn-1709116248194.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/YgWtuGB6ySPtTmZkqRk23hRzAipv0l50-1708113598149.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/iwFuM3wPrGe4UlKdqLxPQTbmMpUpPyLo-1708113603979.png',
          vodCount: 1,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UECL | Group Stage | Matchday 2',
          description:
            'Highlights from the Matchday 2 in the Group Stage from the UEFA Europa Conference League 2023/24 season.',
          id: 20863,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/C7r5dMCotNDlNKvHkT0XmxDSy6LFaOVI-1709116373341.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/iIA61TPSZ0Wgqdo5EnzqyRA2rUHV9PK3-1708113568805.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/t6XJTb2BiEyeeb43S22YkeG6gA6he4iq-1708113571014.png',
          vodCount: 1,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UECL | Group Stage | Matchday 1',
          description:
            'Highlights from the Matchday 1 in the Group Stage from the UEFA Europa Conference League 2023/24 season.',
          id: 20862,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/Yg1x1cZxRx37iOtNDyx0W00aq6jFvaGO-1709116450064.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/4wqq6mz144pORTCgSruAfLk2qludHe2K-1708113541658.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/16/oaHQT0BiPRmHFnmBMan9yxK7g4r23olC-1708113548123.png',
          vodCount: 1,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
      ],
      placeholderData: {},
    },
    {
      type: 'SERIES',
      rowTypeData: {
        background: {
          imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/hujik.PsVWF.zkZ3C.jpg',
          gradientLeft: true,
          gradientRight: true,
          gradientTop: true,
          gradientBottom: true,
          animationType: 'NONE',
        },
        title: 'UEFA CLASSICS',
        description: 'Take a trip down memory lane with our extensive archive of unforgettable matches.',
        rowCount: 1,
        rowType: 'INLINE',
        textAlignment: 'LEFT',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'TITLE',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: 'UEFA CLASSICS',
      exid: 'MFEj',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:1874',
      },
      contentList: [
        {
          type: 'VOD_SERIES',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL Classics',
          description: 'A collection of some of the greatest matches on the elite European stage.',
          id: 1865,
          longDescription: 'Missing translation',
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/zw4qC4ECziZCr0X9qvJiTEfojaci4RwA-1710339266552.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/rserJyRu7fSiNIKR8kvVcFWA8OHLURuM-1710338792322.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/xpZGvDGsoDzcjeoHswjr3zverSa4k03i-1710339271156.png',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'VOD_SERIES',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UEL Classics',
          description: 'Classic matches from the UEFA Europa League.',
          id: 1870,
          longDescription: 'Missing translation',
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/TpEfcPxbmgDZAexStl6wye4Zr5rpjFb2-1710342430077.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/MzscapXPTlfPz3yVha1vrwTPg0cCgJXH-1710342425827.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/gDJoKsRqjQrzmUvKw5GFC2AN7tFJAY0A-1710342434338.png',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'VOD_SERIES',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UECL Classics',
          description: 'The best matches of the UEFA Europa Conference League.',
          id: 1874,
          longDescription: 'Missing translation',
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/VJhoe5lrx7M1GXbWIJkZs9D6QRwnMiCj-1710347360451.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/HDL6VqH2QWPeX4A1Xyi28D3kA36wvV2h-1710347378856.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/0Tdbp3EG3GlX17YuZ2gZQQjNeehwdQfh-1710347373408.png',
          displayableTags: [],
          upcomingReleases: [],
        },
      ],
      placeholderData: {},
    },
    {
      type: 'VOD_VIDEO',
      rowTypeData: {
        background: {
          gradientLeft: false,
          gradientRight: false,
          gradientTop: false,
          gradientBottom: false,
          animationType: 'NONE',
        },
        title: 'UEFA YOUTH LEAGUE HIGHLIGHTS',
        rowCount: 2,
        rowType: 'BASIC',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: false,
        videoDurationDisplayMode: 'SHOW',
      },
      name: 'UEFA YOUTH LEAGUE HIGHLIGHTS',
      exid: '3bgo',
      paging: {
        moreDataAvailable: true,
        lastSeen: '0:587070',
      },
      contentList: [
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights | FC Barcelona v FC Shakhtar Donetsk',
          description: 'See how Barcelona maintained their 100 percent start in the Youth League group stage.',
          id: 587057,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/JJNLDN5ZFJdtcWBbMyVTRVpWkOKP9FGU-1708536408435.png',
          duration: 114,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/tedDA6bR5ElzlveuyCJJnGe00f9DXbW8-1708525524587/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights | Newcastle United v AC Milan',
          description: 'See how Newcastle came from behind to end their Group F campaign with victory.',
          id: 587058,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/4OBdDnRAejzcDKpEliYShLeGIcKm8FMr-1708536140781.png',
          duration: 119,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/7f2H3QJGQ0iJd3bBjjim6BnCHfdRbbsM-1708525559006/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights | FC Bayern München v F.C. Copenhagen',
          description:
            'Watch the best of the action from Munich where a Emirhan Demircan double helped Bayern come from behind to beat the Group A leaders.',
          id: 587060,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/csV1n4BR9EYhvAUomOrIBRQT3QTzmrWy-1708535800430.png',
          duration: 118,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/dvXTxpmSqUu1bXgk2X5vq7ZgMsY5DfWy-1708525576666/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights |  Real Sociedad v Salzburg',
          description: 'See how Salzburg confirmed top spot in Group D with victory in San Sebastian.',
          id: 587061,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/5g6eA0PwXKwg3vGYXk2iVq69NHYGGhVd-1708534640690.png',
          duration: 120,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/IKM2krupH6yrQVCvu8i8Y6NSllzudmPk-1708525649846/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights | Atlético de Madrid v Celtic FC',
          description:
            'See how a Rayane Belid hat-trick helped the hosts gain a comfortable success in the Spanish capital.',
          id: 587062,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/QyRClsxjLhJ9R0TxdZdaBjLtzqsOLllA-1708534295533.png',
          duration: 120,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/ko9VtOlVMmAZnJsni7Zne1UdBFozC20P-1708525650328/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights | Manchester City v RB Leipzig',
          description: 'See how Manchester City came from behind to claim victory in Group G.',
          id: 587063,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/F5kvY8g8MwPEKELGLAFo1hERzxId0sXB-1708534773116.png',
          duration: 118,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/y0v6iJ7zbG0S4315WzmHShi8ssPXZlCR-1708525647865/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights | Arsenal FC v Sevilla FC',
          description:
            'Watch the best of the action from Boreham Wood where Arsenal picked up their first point in Group B.',
          id: 587064,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/czWALnL474cRoYLjBIXlphWyo5SN9kNd-1708535367662.png',
          duration: 119,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/ae2dGuTE4Jjj7R0bwK8Q7zEkybQG2f3T-1708525624574/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights |  FC Basel 1893 v FC Bayern München',
          description:
            'Watch highlights as Bayern captain Lovro Zvonarek struck twice at Basel to send his club into the round of 16 for the third time.',
          id: 587065,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/qzS5W8u6GO00clX6UzKMNosUr7ArnRbw-1708534055688.png',
          duration: 120,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/1hLtVtruOePf9qi6xwALrNY4F1ZAh2Rv-1708525694096/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights |  Feyenoord v Atlético de Madrid',
          description:
            'Watch the best of the action from Rotterdam where a late winner kept the visitors at the summit of Group E.',
          id: 587066,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/EBINwd6B8iwQUOyTYIBxyqZRWEGxqm9K-1708535023809.png',
          duration: 120,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/fhsKKt08kgpNAUWJ9E76d24QjaYB6Q56-1708525635783/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights |  SSC Napoli v SC Braga',
          description:
            'Braga twice led at eliminated Napoli but must settle for Group C second place and a play-off after an entertaining draw.',
          id: 587067,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/KmUp9kSDoetp2GbxtjVsRUm1cBDFgDes-1708531873382.png',
          duration: 119,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/3C89LMYTGYKK8mHvnFxPDgdx7i0huqEf-1708525701635/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights | Borussia Dortmund v Paris Saint-Germain',
          description:
            'Watch the best of the action from Group F where victory for Dortmund gave them a play-off spot.',
          id: 587069,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/4TfBBoPO2zmiQn7BiqIWUuMiQyHi5wUV-1708533817239.png',
          duration: 120,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/H2r48P8KdrPNWCjm5yE3UBIXfAJXyRIf-1708525694312/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UYL Highlights | RC Lens v Sevilla FC',
          description: 'Sevilla came from behind to draw at Group B winners Lens and are into the play-offs.',
          id: 587070,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/21/vEamM40pMswK0KOD0dznALtrViR4Z9I7-1708535230937.png',
          duration: 120,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/21/4T7lfAl2rufICmqjPWL8cXAwj8Ib4NWq-1708525626987/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
      ],
      placeholderData: {},
    },
    {
      type: 'PLAYLISTS',
      rowTypeData: {
        background: {
          imageUrl:
            'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/ftvgbyhjnkm.ZoSes.Bk3Z9.lUOSz.q6rTx.png',
          gradientLeft: true,
          gradientRight: true,
          gradientTop: true,
          gradientBottom: true,
          animationType: 'NONE',
        },
        title: 'UEFA SERIES',
        description:
          'Explore our exclusive and extensive archive with documentaries covering all aspects of the beautiful game.',
        rowCount: 1,
        rowType: 'INLINE',
        textAlignment: 'LEFT',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: 'UEFA SERIES',
      exid: 'ctkc',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:22067',
      },
      contentList: [
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Equals',
          description:
            "This examines the rapid rise of women's football across Europe as well as the challenges that remain, against the backdrop of a record-breaking UEFA Women's EURO 2022, which captivated audiences the world over last summer.",
          id: 21788,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/XS1D1jLvaT0HaJ8IXqqwkKUHhbHPIotP-1709033183055.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/wQU6XuiHXUPuSYdrjuQgr6TGXwFFaJd7-1709077931509.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/ALpbdhoiu9TySNQfwtQ28QK6JD0kQya9-1709033186638.png',
          vodCount: 6,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Man in the Middle',
          description:
            'UEFA’s four-part original series providing fans with an exclusive view of the pressures facing Champions League referees.',
          id: 21790,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/GRAXNayezjf3BwP3FcxpEXEoZONkMQZK-1709037089194.jpg',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/stR0il0eKII1dXg1NHu3P29HtfVDDJZz-1709078119457.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/Og5TgwmKU8wVs2nrK408UfxYX2fvumyA-1709037101330.jpg',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/8r0BvrshDeohw3482qLFh2f9PcZ2rkG2-1709037097577.jpg',
          vodCount: 4,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Official Films',
          description: 'An alternate look at all of the UEFA showpiece events.',
          id: 21792,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/cBrpudIBIkm3SO8Ab411EUiLbXe59rSO-1709042514333.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/kybAjNNusd6QtwZ04V0mE2TNPTLefpt9-1709078505860.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/QejzyDz3VQTgcQGMzQiqxXPiP1E1C5t1-1709042510342.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/UuztdDjqI0xhMBYTmem1xnxwXwpNdutu-1709042518042.png',
          vodCount: 4,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Outraged',
          description:
            'Paul Pogba, Moise Kean, Dejan Lovren, Nadia Nadim, Shanice van de Sanden and Guram Kashia share their personal experiences of discrimination and how these issues are affecting people in football. ',
          id: 21789,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/Ahu3vmpgWYFd3PptxiNzJkK97Pt6cKFm-1709035569949.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/H0tNKGMSQWAE3IQjStzU4GGAjMf6AykK-1709078179032.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/eS0MvpZWc2AfksyMVgY1RpdzI5QZIWZh-1709035567899.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/UKyCjkUV0BRyYjv55Swp5KohZtWek98K-1709035572623.png',
          vodCount: 5,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Think Fast',
          description:
            'A new futsal documentary celebrating the sport, featuring the stars of the game and exclusive behind-the-scenes footage.',
          id: 21796,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/hgDOSCfBc8U4gmCXe7watFYDQukh2Ab9-1709044807842.png',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/28/AtdPWGvfuv9ycZI5TYh7VkYV2P9BjRl4-1709078642156.png',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/s7i0KwD38bchyziMhCJz6sxEMtIxkvfX-1709044811059.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/ATCr4liUjjj97fWFgN0jq10nvsoRQxxt-1709044814044.png',
          vodCount: 2,
          playlistType: 'BASIC',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL 16/17',
          description: 'Classic matches from the UEFA Champions league',
          id: 22058,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/14/nNoQB6lPS1b8Po4GvKKnpUXCTWThfvDI-1710398567367.jpg',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/LKtfRaX8Hh0G7enVOqqWF0u3Kh4guC1c-1710338251885.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/5H4X8Z5nY89XoB0HWbIhfiA53qO5l3w1-1710338261996.png',
          vodCount: 3,
          playlistType: 'SEASON',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL 18/19 ',
          description: 'Classic Matches from the UEFA Champions League.',
          id: 22059,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/14/pUW8ULch2xTw1nAGaU2NCH1AvnqVmK18-1710398543322.jpg',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/CXO6O4IeSPzFmQ3GQTDstFR6kl5AbGlU-1710338385166.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/CVuHgoXIZWjxYHwOjSJOjfQmQkOKEdpO-1710338391681.png',
          vodCount: 2,
          playlistType: 'SEASON',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL 19/20',
          description: 'Classic matches from the UEFA Champions League',
          id: 22060,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/14/dqjVTOZPYXEBrU7StrwlnNceudBYxaqD-1710398669135.jpg',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/HPV9utPorijX7NV7WSzgaCWEC0GKwCVi-1710338469118.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/PDiG4dDt4cV3gAz4z5MZKQqSu2yTZuu1-1710338477768.png',
          vodCount: 2,
          playlistType: 'SEASON',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UCL 20/21',
          description: 'Classic matches from the UEFA Champions League.',
          id: 22062,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/14/0rHRrTmO36RUkAHj4HTb66HJar3W31Fs-1710398733681.jpg',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/vC7i1A7ZNmTSNaBI5o9pUTY09jAtLEbp-1710338592759.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/mO1JYZnoJ4csQokTDFPxoqdKThLZe7tj-1710338598364.png',
          vodCount: 2,
          playlistType: 'SEASON',
          displayableTags: [],
          upcomingReleases: [],
        },
        {
          type: 'PLAYLIST',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'UEL 16/17',
          description: 'Classic matches from the UEFA Europa League.',
          id: 22067,
          coverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/14/DPUYjeRW42rJKA016Ja0zf5smoWfSAVo-1710398847831.jpg',
          smallCoverUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/e25poddqZzeE3mbh1lGdwsUmaifSxlCp-1710342144442.png',
          titleUrl:
            'https://dve-images.imggaming.com/original/p/2024/03/13/7MukHxiLtBfcZHE72f9ZVJrXfM1LV6CX-1710342156638.png',
          vodCount: 2,
          playlistType: 'SEASON',
          displayableTags: [],
          upcomingReleases: [],
        },
      ],
      placeholderData: {},
    },
    {
      type: 'VOD_VIDEO',
      rowTypeData: {
        background: {
          gradientLeft: false,
          gradientRight: false,
          gradientTop: false,
          gradientBottom: false,
          animationType: 'NONE',
        },
        title: 'PLAYER FOCUS',
        rowCount: 1,
        rowType: 'BASIC',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: 'PLAYER FOCUS',
      exid: 'pTaJ',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:586524',
      },
      contentList: [
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Rafael Leão',
          description:
            'The Milan forward shows off his love for music and songwriting with a passionate performance in front of our cameras.',
          id: 585480,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/JazGZKmUJYhkhCv8vckBvwtLcIKYDlJ8-1708445031236.png',
          duration: 317,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/17/LJyewgUuE2yoUzNBAZpWskmJIRYzcPFl-1708174491327/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Manuel Akanji',
          description:
            'We sit down with the Swiss defender as he unveils the stories behind his tattoos and shares his emotions following a triumphant treble win with Manchester City.',
          id: 585486,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/yKZY0rtDNSLdhqfe4zurUjXaROY8yPaa-1708446567072.png',
          duration: 189,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/17/lHqFLQOxEQZM2uwDRJkonQaNWOk0VbD2-1708176458791/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Gift Orban',
          description:
            'We meet the Gent striker, the latest in a long line of Nigerian players to make their mark on the European stage.',
          id: 586052,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/18/wIzEWrSAE5nJFaPG3qAfgqfZf5jeLIKD-1708260703296.png',
          duration: 273,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/18/16wjd9qVr8QJ6bbqVJts4Tt9cgdzWcaN-1708259863313/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | João Mário',
          description:
            "We sit down with Benfica's João Mário to talk about his team's journey and his responsibilities as vice-captain.",
          id: 586062,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/VBu3gzHD52zxE8Wkw2fUcgCJ030UsVMu-1708445429707.png',
          duration: 180,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/18/TMAslRGnik4zsod88WSO39fUmh0Hiqup-1708265087002/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Xavi Simons',
          description:
            "We get up close and personal with one of Europe's most exciting talents, tracing his journey from Barcelona to Leipzig.",
          id: 586309,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/I9N7QDEpYl8RqpbwczlO2knDKSGA6zWA-1708446396836.png',
          duration: 201,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/19/EFUHiNfIGBpu04tz3bII9adRvQw2NFmu-1708344973044/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Daniel Parejo',
          description: "The Villarreal midfielder looks back on his club's relationship with the UEFA Europa League.",
          id: 586312,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/JUlQXuJBDwnvZ0JOAeecAeJYBP1Jd4xw-1708445167083.png',
          duration: 258,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/19/8Xa22Yo0tdEPBnZFTMTTOLltSj5EX2HB-1708345877764/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Achraf Hakimi',
          description:
            'We meet the Parisian star to explore his career, starting at Real Madrid, and discover insights into his French connections with Kylian Mbappé and Zinedine Zidane.',
          id: 586521,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/0N24w2yPcjtXg9C6N44h4ZA8iMC4vnAv-1708446330513.png',
          duration: 253,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/zCh1iTE5Ln70Bc5I2URVb26n03Ht6Gk6-1708425039640/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Matheus Reis',
          description:
            'We meet the defender and discuss his journey from Brazil to European football with Sporting CP.',
          id: 586524,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/S4DaxoepeqLVxxSR4veGiOU4UxRjH2sJ-1708445268293.png',
          duration: 209,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/Pd2OqACT5mndCGuIYUJIK7g9a0gOOXMw-1708426453416/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
      ],
      placeholderData: {},
    },
    {
      type: 'VOD_VIDEO',
      rowTypeData: {
        background: {
          gradientLeft: false,
          gradientRight: false,
          gradientTop: false,
          gradientBottom: false,
          animationType: 'NONE',
        },
        title: ' ',
        rowCount: 1,
        rowType: 'BASIC',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: ' ',
      exid: 'Ww4-',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:586569',
      },
      contentList: [
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Carlos Tevez',
          description:
            'The Champions League winner shares insights into his remarkable career, spanning from Buenos Aires to his journey in Europe, culminating in winning the title with Manchester United.',
          id: 586544,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/HuBn5dI4ZELzTon5KXf9z6IGTMPkdZ2g-1708446245838.png',
          duration: 305,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/Fvmz1KprClzS2I0TDXGfOaxTlHVT74wW-1708437574370/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Ademola Lookman',
          description:
            'The Atalanta forward retraces his steps from humble beginnings to the glory of the UEFA Europa League.',
          id: 586550,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/LptQKMTga2zIOMnHwQIeC3RUx8CLfhGp-1708444954168.png',
          duration: 255,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/1ljKEVz5WQIRzMZYeTB9I8yq6je0xDXu-1708438268534/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Leroy Sané',
          description:
            'The German star talks through his career, beginning with Schalke, moving to Manchester and achieving success with Bayern.',
          id: 586551,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/tAIkx34czECMHfSeYBqxbjmcbrCTiZIn-1708446489426.png',
          duration: 164,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/h4S2Qag4siVn5zzHSWUckMQe8KnRNc02-1708438695529/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | João Neves',
          description:
            'We hear from the latest academy graduate to break in to the Benfica first team, as the 19-year-oldmtells us his story.',
          id: 586553,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/SnHsmkOcKl3qzU71cZjIZtePAOd9kdul-1708446728930.png',
          duration: 179,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/IfwOhrbWFzOaJc6kH65PkHK5WfdLjgon-1708439306506/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Tuta',
          description:
            "We meet Frankfurt's defender Tuta and know more about his journey and his UEFA Europa League title in 2022.",
          id: 586556,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/wswsSffA3l3WfoSSi8uWVxu3XnXSTinS-1708439884395.png',
          duration: 222,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/3lQQqoIZ2RCHPFWfsmBqn3fdT3A2yDqp-1708439796527/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Victor Boniface',
          description: "We sit down with Leverkusen's Nigerian striker.",
          id: 586563,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/OFD41gihq7IHOlppAiTzVXmG90FS1I0v-1708444772495.png',
          duration: 148,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/fILAYzXZsLficoOLIxSHDnPh5kkNtoum-1708440349762/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Al Musrati',
          description: "We hear from Braga's Libyan midfielder.",
          id: 586568,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/npVCaJ8IeES0os6oKf00YLUXbs3Wt8ri-1708446653323.png',
          duration: 179,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/YxeoMKu6sdfJbuKRn1nqGoEYOvLJyjtn-1708441472156/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Player Focus | Jamal Musiala',
          description:
            "We sit down with Bayern's fast-rising talent and look back on his journey from starlet to superstar.",
          id: 586569,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/ZtmnlSVeJIOCyQ2QlFP8nhoYaTbHG3Ul-1708446804960.png',
          duration: 218,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/zzae28SYkrjkPVOzbOtLaA1vY8OIJKTh-1708442174571/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
      ],
      placeholderData: {},
    },
    {
      type: 'VOD_VIDEO',
      rowTypeData: {
        background: {
          imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/JNKMS_2CLS.irw3X.fM0R1.png',
          gradientLeft: true,
          gradientRight: true,
          gradientTop: true,
          gradientBottom: true,
          animationType: 'NONE',
        },
        title: 'UCL ROUND OF 16',
        description: 'Look ahead to the knockout stages with our dedicated previews of each tie!',
        rowCount: 1,
        rowType: 'FEATURED',
        textAlignment: 'CENTER',
        displayPosters: true,
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: 'UCL ROUND OF 16',
      exid: 'ss-V',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:586589',
      },
      contentList: [
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Head-to-Head | FC Copenhagen v Manchester City',
          description:
            "Here's all the stats ahead of the UEFA Champions League Round of 16 tie between the Danish outfit and 2022/23 European title-holders.",
          id: 586586,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/HapLXSgxMOsMWU57z3Eb3D52bN3muOPS-1708447804836.jpg',
          duration: 116,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/nyIJcmdFXphEJaz09RybTgV95DKHbEDw-1708447804954/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Head-to-Head | FC Porto v Arsenal',
          description:
            'Look ahead to the UEFA Champions League Round of 16 tie between the Portuguese champs and the Gunners.',
          id: 586587,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/1dXOwejk3Y4n4TPz6sEf02Ttd2e7dQqg-1708447858653.jpg',
          duration: 121,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/M1ewQoNx5LEksx1RWzfrlFt6JwAJJd17-1708452868150.png',
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/XYKsXbpU5x0U9UC84ScWt6m2lu8t0Vu2-1708447858758/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Head-to-Head | Inter Milan v Atlético Madrid',
          description:
            'We look ahead to the UEFA Champions League Round of 16 tie between representatives of the Italian and Spanish capitals.',
          id: 586582,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/vtEs9cmJE259RAhguXzhllZs3mPsQLvW-1708447618525.jpg',
          // posterUrl:
          //   'https://dve-images.imggaming.com/original/p/2024/02/20/6MhKUryRFzopwL3t22vbKRwvavwzPWu3-1708457639337.png',
          duration: 85,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/tQFqaf7ODg9Y19uqvAmnTeh3YvKzbXNt-1708447618685/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Head-to-Head | Lazio v FC Bayern Munich',
          description:
            'Get all the info you need ahead of UEFA Champions League Round of 16 tie between the Italian outfit and German giants.',
          id: 586585,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/DIdkcUw2LICFQPFCiOX6XLNOMuKG4a2h-1708447746396.jpg',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/nnYDpt1QPc6RRUUfkrkybrhYKdtWb9Jm-1708454451511.png',
          duration: 106,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/L4IatNyqIyVuZJfjDdml1sSZr6K8YUH0-1708447746535/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Head-to-Head | Napoli v Barcelona',
          description:
            'We preview the UEFA Champions League Round of 16 meeting between the Italian supremes and Catalonian giants.',
          id: 586588,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/NobjoWtYqJvjZi52KuGADNVwAwJ1J9ee-1708447924861.jpg',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/PuHdYXgYxU7nhE9YJNc9GUMCnuMEnSbJ-1708452038690.png',
          duration: 127,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/VAqK3OZvboKy5sIQL9JjbQI2t11u7JuH-1708447924989/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Head-to-Head | PSG v Real Sociedad',
          description:
            'We gather the stats ahead of the Champions League Round of 16 tie between the French Goliaths and Spanish contenders.',
          id: 586584,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/Wa0bizUgBLxMHBeU4uIcuPJ6Cet2Sh9K-1708447698293.jpg',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/vqNjRj7AYocsyrf4ZMQN9J23Zpq3Q33C-1708455833170.png',
          duration: 104,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/5goPYJBtmCN79UKH99ADp5e59FENUxE8-1708447698412/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Head-to-Head | PSV v Borussia Dortmund',
          description: 'Preview the UEFA Champions League Round of 16 tie between the Dutch giants and Yellow Wall.',
          id: 586583,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/2o2Wc0cHIVYB7NyJfaXpY3WpPTbQ7yKC-1708447658218.jpg',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/5eAfHBoCIGh8QiujeoSgEN1urw1WtoLq-1708457340963.png',
          duration: 102,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/da8iNVaon7GW7ymsdHUvgBCcdSf88eWA-1708447658382/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Head-to-Head | RB Leipzig v Real Madrid',
          description:
            'We look ahead to the UEFA Champions League Round of 16 clash between the German side and Spanish giants.',
          id: 586589,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/FwbUDNMAtkLmBjLU88kKdik21bCdH3tY-1708447970076.jpg',
          posterUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/20/7zNN758b6oIRJZNtfhgUKx8myqdHXTTF-1708452185491.png',
          duration: 134,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/20/xjsIaR0NxxA352qpCeGPPnkpL5zilQGV-1708447970201/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
      ],
      placeholderData: {},
    },
    {
      type: 'VOD_VIDEO',
      rowTypeData: {
        background: {
          imageUrl: 'https://static.diceplatform.com/prod/original/dce.uefapoc/section/2970/SVGBHNJM.1670Z.9y6CK.png',
          gradientLeft: true,
          gradientRight: true,
          gradientTop: true,
          gradientBottom: true,
          animationType: 'NONE',
        },
        title: 'ALL QUALIFYING GOALS',
        description: "Relive nation's journeys towards Euro 2024 with our dedicated compliations!",
        rowCount: 1,
        rowType: 'FEATURED',
        textAlignment: 'CENTER',
        contentDescription: 'HIDE',
        focusStyle: 'NONE',
        playlistImageType: 'NONE',
        hideMetadata: true,
        videoDurationDisplayMode: 'SHOW',
      },
      name: 'ALL QUALIFYING GOALS',
      exid: '3gXP',
      paging: {
        moreDataAvailable: false,
        lastSeen: '0:589842',
      },
      contentList: [
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Belgium | Euro 2024 Qualifying - All Goals',
          description: 'Watch every goal scored by Belgium in the EURO 2024 qualifying campaign.',
          id: 589841,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/aml8wb12BxT2K7d5u6u2PRxGXXdPOuXH-1709076613451.png',
          duration: 383,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/27/Ti3w2tN1O8zQVOXkfxcx0o3ZhZi7XXhh-1709055115596/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Croatia | Euro 2024 Qualifying - All Goals',
          description: 'Watch every goal scored by Croatia in the EURO 2024 qualifying campaign.',
          id: 589849,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/TJ87HOX2gc36zDhFj4pKgYutrRdu14yE-1709074774345.png',
          duration: 275,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/27/2cpPf1PyQWhWdgC4SlWnge2uTeyXwNOf-1709055369549/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'France | Euro 2024 Qualifying - All Goals',
          description: 'Watch every goal scored by France in the EURO 2024 qualifying campaign.',
          id: 589843,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/oK2uG6eiy8SVlG8j6llBYse7tYJd0WVY-1709075286611.png',
          duration: 486,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/27/Lrhg1XXSGKmUiQfIL148MmsozigRsQei-1709055242274/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Italy | Euro 2024 Qualifying - All Goals',
          description: 'Watch every goal scored by Italy in the EURO 2024 qualifying campaign.',
          id: 589838,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/Y0Qm7596giiaa43Utj4f1QLJOOjFOyxK-1709076874011.png',
          duration: 264,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/27/W8DuibnJNCD69X2wPlfHjZblXJJOgZP7-1709054992673/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Netherlands | Euro 2024 Qualifying - All Goals',
          description: 'Watch every goal scored by Netherlands in the EURO 2024 qualifying campaign.',
          id: 589839,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/0Bev6259NEChZtIvTCRRRk2VWqQnegdB-1709057073451.png',
          duration: 264,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/27/6N9T7XBi8ndUzky5NpewdTYHaiPd6REj-1709055032225/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Portugal | Euro 2024 Qualifying - All Goals',
          description: 'Watch every goal scored by Portugal in the EURO 2024 qualifying campaign.',
          id: 589844,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/J5PagqZCWL1tAfW5cilVgBr4DSZ1TACe-1709076360635.png',
          duration: 600,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/27/xNLmf0Ea2az9MKH9ipIBagSiLe0jvQKZ-1709055307569/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Scotland | Euro 2024 Qualifying - All Goals',
          description: 'Watch every goal scored by Scotland in the EURO 2024 qualifying campaign.',
          id: 589840,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/MkhBxsNH576AyMF1xJuAG5o6aHld9go6-1709075644796.png',
          duration: 340,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/27/kDbjrb6QB8R46Rs8Zlq7igUrz0khDZDy-1709055073307/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
        {
          type: 'VOD',
          accessLevel: 'GRANTED',
          licenceIds: [],
          title: 'Spain | Euro 2024 Qualifying - All Goals',
          description: 'Watch every goal scored by Spain in the EURO 2024 qualifying campaign.',
          id: 589842,
          thumbnailUrl:
            'https://dve-images.imggaming.com/original/p/2024/02/27/ImULVDhlo8GtPl62A6tQCCJmui0SNTLf-1709075976426.png',
          duration: 409,
          favourite: false,
          watchContext: [],
          offlinePlaybackLanguages: [],
          maxHeight: 1080,
          thumbnailsPreview:
            'https://dve-images.imggaming.com/original/p/2024/02/27/Kz8n9gEEnNQQ5Q1gzlT6ai8eeQs08aYR-1709055160903/bif/preview_thumbnails.bif',
          subEvents: [],
          contentDownload: {
            permission: 'DISALLOWED',
          },
          displayableTags: [],
          computedReleases: [],
          watchStatus: 'NOT_AVAILABLE',
          playbackType: 'ON_DEMAND',
          onlinePlayback: 'AVAILABLE',
        },
      ],
      placeholderData: {},
    },
  ],
  licences: [],
  bucketShortcuts: {
    items: [],
    paging: {
      moreDataAvailable: false,
    },
    iconsStatus: 'HIDE',
  },
  paging: {
    moreDataAvailable: true,
    lastSeen: 'ctkc',
  },
};
